

























import Vue from 'vue'
import Component from 'vue-class-component';

@Component
export default class FormSaved extends Vue {
    name: string = "FormSaved";
    applicationNumber: string = "";

    mounted() {
        this.applicationNumber = this.$route.params.applicationNumber;
    }

    home(): void {
        this.$router.push({ path: "/" });
    }
}
